<template>
	<header class="provider-header">
		<div class="header-content">
			<router-link to="/provider/profile" class="brand">
				<img src="@/assets/logo.png" alt="楚建通" />
				<span class="brand-divider"></span>
				<span class="brand-title">服务商工作台</span>
			</router-link>

			<div v-click-outside="handleCloseUserMenu" class="account-area">
				<button type="button" class="account-trigger" :class="{ active: showUserMenu }" @click.stop="toggleUserMenu">
					<span class="user-avatar">
						<img src="@/assets/user/user-avator.png" alt="用户头像" />
					</span>
					<span class="user-copy">
						<span class="user-name">{{ realName || '服务商用户' }}</span>
						<span class="user-role">服务商账号</span>
					</span>
					<i class="menu-arrow el-icon-arrow-down" :class="{ rotated: showUserMenu }"></i>
				</button>

				<div v-show="showUserMenu" class="account-dropdown">
					<button type="button" class="dropdown-item switch-item" @click.stop="handleSwitchConsumer">
						<i class="el-icon-monitor"></i>
						<span>切换至消费者端</span>
						<i class="item-arrow el-icon-arrow-right"></i>
					</button>
					<div class="dropdown-divider"></div>
					<button type="button" class="dropdown-item logout-item" @click.stop="handleLogout">
						<i class="el-icon-switch-button"></i>
						<span>退出登录</span>
					</button>
				</div>
			</div>
		</div>
	</header>
</template>

<script>
	import { mapGetters } from 'vuex'
	import unifiedAuthMixin from '@/mixins/unifiedAuth'

	export default {
		name: 'ProviderHeader',
		mixins: [unifiedAuthMixin],
		data() {
			return {
				showUserMenu: false
			}
		},
		computed: {
			...mapGetters(['realName'])
		},
		methods: {
			toggleUserMenu() {
				this.showUserMenu = !this.showUserMenu
			},
			handleCloseUserMenu() {
				this.showUserMenu = false
			},
			// 切换端仅改变工作台路由，沿用当前登录态，不重新请求登录。
			handleSwitchConsumer() {
				this.showUserMenu = false
				if (this.$route.path !== '/index') {
					this.$router.push('/index').catch(error => {
						if (error.name !== 'NavigationDuplicated') {
							throw error
						}
					})
				}
			},
			handleLogout() {
				this.showUserMenu = false
				this.unifiedAuthLogout()
			}
		}
	}
</script>

<style lang="scss" scoped>
	.provider-header {
		position: relative;
		z-index: 10;
		height: 72px;
		border-bottom: 1px solid #e4e9ef;
		background: #ffffff;
		box-shadow: 0 2px 10px rgba(31, 55, 86, 0.06);
	}

	.header-content {
		display: flex;
		align-items: center;
		justify-content: space-between;
		height: 100%;
		padding: 0 32px;
	}

	.brand {
		display: inline-flex;
		align-items: center;
		color: inherit;
		text-decoration: none;

		img {
			display: block;
			width: auto;
			height: 42px;
		}
	}

	.brand-divider {
		width: 1px;
		height: 28px;
		margin: 0 18px;
		background: #d7dde5;
	}

	.brand-title {
		color: #344154;
		font-size: 20px;
		font-weight: 600;
		letter-spacing: 1px;
	}

	.account-area {
		position: relative;
		display: flex;
		align-items: center;
	}

	.account-trigger {
		display: flex;
		align-items: center;
		padding: 7px 10px;
		border: none;
		border-radius: 6px;
		background: transparent;
		cursor: pointer;
		transition: background-color 0.2s ease;

		&:hover,
		&.active {
			background: #f3f7fc;
		}
	}

	.user-avatar {
		width: 38px;
		height: 38px;
		margin-right: 10px;
		overflow: hidden;
		border: 2px solid #e4effc;
		border-radius: 50%;

		img {
			display: block;
			width: 100%;
			height: 100%;
			object-fit: cover;
		}
	}

	.user-copy {
		display: flex;
		flex-direction: column;
		min-width: 90px;
	}

	.user-name {
		max-width: 150px;
		overflow: hidden;
		color: #303846;
		font-size: 14px;
		font-weight: 500;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.user-role {
		margin-top: 3px;
		color: #98a0ac;
		font-size: 12px;
	}

	.menu-arrow {
		margin-left: 12px;
		color: #8d97a5;
		font-size: 12px;
		transition: transform 0.2s ease;

		&.rotated {
			transform: rotate(180deg);
		}
	}

	.account-dropdown {
		position: absolute;
		top: calc(100% + 10px);
		right: 0;
		width: 200px;
		padding: 8px 0;
		border: 1px solid #e4eaf1;
		border-radius: 6px;
		background: #ffffff;
		box-shadow: 0 8px 24px rgba(31, 55, 86, 0.12);
	}

	.dropdown-item {
		display: flex;
		align-items: center;
		width: 100%;
		padding: 11px 16px;
		border: none;
		color: #4d5969;
		font-size: 14px;
		text-align: left;
		background: transparent;
		cursor: pointer;
		transition: color 0.2s ease, background-color 0.2s ease;

		> i:first-child {
			margin-right: 6px;
		}

		&:hover {
			color: #236fca;
			background: #f3f7fc;
		}
	}

	.switch-item {
		color: #236fca;
	}

	.item-arrow {
		margin-left: auto;
		font-size: 12px;
	}

	.dropdown-divider {
		height: 1px;
		margin: 4px 0;
		background: #edf0f4;
	}

	.logout-item:hover {
		color: #f56c6c;
		background: #fef0f0;
	}
</style>
